import type { SubmitFeedbackResponseDto, SubmitNewProspectResponseDto } from '@api/generated/models';
import type { SubmitFeedbackResponse, SubmitNewProspectResponse } from '@api/domain/types';

export const toSubmitFeedbackResponse = (dto: SubmitFeedbackResponseDto): SubmitFeedbackResponse => dto;
export const toSubmitNewProspectResponse = (dto: SubmitNewProspectResponseDto): SubmitNewProspectResponse => dto;
